import React, { Component } from "react";
import { MDBTextArea } from "mdb-react-ui-kit";

export default class DescriptionSection extends Component {
  render() {
    const { value = "", onChange } = this.props;
    return (
      <section className="project-shortdesc-section">
        <h3 className="project-subtitle">Descripción breve</h3>
        <MDBTextArea
          rows={3}
          className="project-shortdesc-input"
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          placeholder="Añade una descripción breve del proyecto…"
        />
      </section>
    );
  }
}
